import React from "react";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

export function QuranrtImageGallery() {
  const data = [
    {
      imageLink: "assets/images/projects/quranRT/qrt1.jpg",
    },
    {
      imageLink: "assets/images/projects/quranRT/qrt2.jpg",
    },
  ];

  const [isOpen, setIsOpen] = React.useState(false);
  const [active, setActive] = React.useState(0);
  const slides = data.map(({ imageLink }) => ({
    src: imageLink,
  }));

  return (
    <div className="flex">
      <div className="w-24 max-h-[23rem] overflow-y-auto overflow-x-hidden">
        {data.map(({ imageLink }, index) => (
          <div
            key={index}
            className="w-20 h-20 mb-2 last:mb-0 border border-gray-300 overflow-hidden rounded-lg hover:shadow-lg"
          >
            <img
              onClick={() => setActive(index)}
              src={imageLink}
              className="h-20 w-20 cursor-pointer object-cover object-center"
              alt="gallery-image"
            />
          </div>
        ))}
      </div>
      <div className="w-[calc(100%-6rem)] max-h-[23rem] aspect-square">
        <div className="group overflow-hidden border border-gray-200 shadow-lg rounded-lg size-full flex items-center justify-center">
          <button onClick={() => setIsOpen(true)} title="Click to expand">
            <img
              className="w-full h-full object-contain object-center"
              src={data[active].imageLink}
              alt={`Gallery img ${active + 1}`}
            />
          </button>
          <Lightbox
            open={isOpen}
            close={() => setIsOpen(false)}
            slides={slides}
            index={active}
          />
        </div>
      </div>
    </div>
  );
}
